import { useCallback, useRef } from 'react';
import { CSSTransition } from 'react-transition-group';
import classnames from 'classnames';

import {
  type Group,
  type MobileHeaderPageStackItem,
  type SubLink,
  type SublinkItem } from
'~/interfaces/HeaderFooterNavV2';

import DrawerMenuLinks from '../drawer-menu-links';
import PromoCodeDropdown from '../menu/promo-code-dropdown';
import SplitNavLinks from '../split-nav-links';

import styles from './SubComponent.module.css';

interface SubComponentProps {
  callback?: (text: string) => void;
  groups: Group[];
  items: SublinkItem[];
  label: string;
  name: string;
  pageClick: (item: MobileHeaderPageStackItem) => void;
  showLinksPage: boolean;
  subLinks: SubLink[];
  type: string;
}

export const SubComponent = ({
  callback,
  groups,
  items,
  label,
  name,
  pageClick,
  showLinksPage,
  subLinks,
  type
}: SubComponentProps) => {
  const nodeRef = useRef(null);

  const isPromoCodesDropdown = name === 'Promo Codes';
  const isSplitDropdown = type === 'SPLIT_EXPANDABLE';

  const styleClass = isSplitDropdown ?
  styles.pageSplitNav :
  isPromoCodesDropdown ?
  styles.pagePromoCodes :
  '';
  const classes = classnames(styles.page, styleClass);

  const subComponent = useCallback(() => {
    switch (true) {
      case !!isSplitDropdown:
        return (
          <SplitNavLinks
            callback={callback}
            label={`${label} - ${name}`}
            links={groups} />);



      case !!isPromoCodesDropdown:
        return (
          <PromoCodeDropdown
            callback={callback}
            label={`${label} - ${name}`}
            links={items} />);



      default:
        return (
          <DrawerMenuLinks
            label={`${label} - ${name}`}
            pageClick={pageClick}
            pages={subLinks}
            trackMenu={callback} />);


    }
  }, [
  callback,
  groups,
  items,
  label,
  name,
  pageClick,
  subLinks,
  isPromoCodesDropdown,
  isSplitDropdown]
  );

  return (
    <CSSTransition
      classNames={{
        enter: styles.pageEnter,
        enterActive: styles.pageEnterActive,
        enterDone: styles.visible,
        exit: styles.pageExit,
        exitActive: styles.pageExitActive
      }}
      in={showLinksPage}
      nodeRef={nodeRef}
      timeout={1000}>

			<div className={classes} ref={nodeRef}>
				{subComponent()}
			</div>
		</CSSTransition>);

};